/* eslint-disable */
// GENERATED by scripts/generate-config.mjs - do not edit, do not commit.
// Source: config/customers/windward.json
const customer = {
  "$comment": "The first customer of the warehouse-inventory product. Everything customer-specific lives here; src/config/brand.js is the only module that reads it. Adding a second customer means adding a sibling file, never a fork.",
  "id": "windward",
  "shellName": "Windward & Kimball Warehouse Portal",
  "shortName": "Windward",
  "$comment_organizations": "The operating companies that share this portal, each billing its own customers. Every customer and job belongs to exactly one, by id (docs/changes/organization-scoping/SPEC.md). Selecting one shows its logo in the app bar; logo.favicon and palette are optional, and while it is selected they replace the browser-tab icon and override the shell's palette key by key. remitTo is the block printed on the storage invoice, printed line for line; its name is the legal name, which need not match the display name. Without one the invoice shows the organization's name alone. Both addresses are as the owner gave them on 2026-09-28: Kimball remits to the same street address as Windward.",
  "organizations": [
    {
      "id": "windward",
      "name": "Windward Investors",
      "shortName": "Windward",
      "logo": {
        "path": "config/customers/windward/logo.png",
        "alt": "Windward Investors"
      },
      "remitTo": {
        "name": "Windward Investors",
        "lines": [
          "2195 Pendley Road",
          "Cumming, GA 30041"
        ]
      }
    },
    {
      "id": "kimball",
      "name": "Roger Kimball Trucking",
      "shortName": "Kimball",
      "logo": {
        "path": "config/customers/windward/kimball-logo.png",
        "favicon": "config/customers/windward/kimball-favicon.png",
        "alt": "Roger Kimball Trucking"
      },
      "palette": {
        "$comment": "The RKT mark is black, so Kimball's bar and primary buttons are black, and the switch's lit button is white rather than the shell's gold. Keys not given here are the shell's.",
        "primary": "#000000",
        "primaryContrastText": "#ffffff",
        "secondary": "#2b2b2b",
        "secondaryContrastText": "#ffffff",
        "accent": "#6b6b6b",
        "highlight": "#ffffff"
      },
      "remitTo": {
        "name": "Roger Kimball Transportation Inc",
        "lines": [
          "2195 Pendley Road",
          "Cumming, GA 30041"
        ]
      }
    }
  ],
  "logo": {
    "path": "config/customers/windward/logo.png",
    "favicon": "config/customers/windward/favicon.ico",
    "icon": "config/customers/windward/icon.png",
    "alt": "Windward Investors"
  },
  "palette": {
    "$comment": "primary is the dark green sampled from the lion-and-tower logo; secondary is a shade darker.",
    "primary": "#283618",
    "primaryContrastText": "#ffffff",
    "secondary": "#1B2510",
    "secondaryContrastText": "#ffffff",
    "accent": "#7C8F5E",
    "error": "#b03a2e",
    "warning": "#c9a227"
  },
  "support": {
    "email": "",
    "phone": ""
  },
  "auth": {
    "$comment": "Cognito identifiers are created by the Phase 2 CDK stack and reach the build as REACT_APP_COGNITO_* environment variables per Amplify branch. Nothing here is a secret and nothing here is a real resource id yet.",
    "region": "us-east-1",
    "userPoolId": "",
    "userPoolWebClientId": "",
    "hostedUIDomain": "",
    "mfa": "OPTIONAL",
    "federatedProviders": [],
    "inviteEmailDomains": [],
    "microsoft": {
      "$comment": "Microsoft sign-in, docs/changes/microsoft-sign-in/SPEC.md. Staff on emailDomains sign in with Microsoft only; the pre-sign-up trigger refuses them a password. The tenant is shared with another customer, so the Enterprise application's assignment list is what keeps that customer's staff out. The client secret is in Secrets Manager, never here; its expiry and rotation are in infra/README.md.",
      "providerName": "Microsoft",
      "tenantId": "e9282ccc-f0e6-49c7-98bd-91ffb2be8634",
      "clientId": "5a1aba88-1831-439d-99f0-f7b13855eca8",
      "clientSecretName": "windward/microsoft-sign-in",
      "clientSecretKey": "clientSecret",
      "emailDomains": [
        "windwardinvestors.com"
      ]
    }
  },
  "storageBilling": {
    "$comment": "employee-portal hard-coded TDMH carve-outs into the storage-billing SQL (mysql-get-inventory.js) with no explanation of why any given id was excluded. They are configuration here, and they start empty: Windward has no carve-outs, and inventing TDMH's would be inventing business rules. See docs/changes/phase-1-extraction/FINDINGS.md.",
    "excludedControlNumbers": [],
    "excludedControlNumberPatterns": [],
    "excludedCustomerIds": []
  },
  "features": {
    "billsOfLading": true,
    "storageBilling": true,
    "customerSharePortal": true,
    "printTags": true,
    "usageAnalytics": true
  }
};

export default customer;
